import * as React from 'react';
const Chrome = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-chrome", ...props },
    React.createElement("circle", { cx: "12", cy: "12", r: "10" }),
    React.createElement("circle", { cx: "12", cy: "12", r: "4" }),
    React.createElement("line", { x1: "21.17", y1: "8", x2: "12", y2: "8" }),
    React.createElement("line", { x1: "3.95", y1: "6.06", x2: "8.54", y2: "14" }),
    React.createElement("line", { x1: "10.88", y1: "21.94", x2: "15.46", y2: "14" })));
export default Chrome;
//# sourceMappingURL=Chrome.js.map